import { REQUEST_STATUSES } from "../../../constants";

const initialState = {
  elements: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const elementsSelector = (propertyId, experienceId) => (state) => ({
  ...initialState,
  ...(state.elements[`${propertyId}${experienceId}`] || {}),
});
